import { useOrgCtx } from "../../hooks";
import { OrgCategoryList } from "./OrgCategoryList";
import { useFeatureFlagValue, FeatureFlag } from "../../../feature-flags";

export function OrgList() {
  const orgCtx = useOrgCtx();
  const personalOrgsEnabled = useFeatureFlagValue(FeatureFlag.EnablePersonalOrgs);

  return (
    <>
      <OrgCategoryList
        category="public"
        description="All users can read documents from here."
        orgCtx={orgCtx}
      />

      <OrgCategoryList
        category="internal"
        description="Private to members and administrators of these organisations."
        orgCtx={orgCtx}
      />

      {personalOrgsEnabled && (
        <OrgCategoryList
          category="personal"
          description="Private to you only."
          orgCtx={orgCtx}
        />
      )}
    </>
  );
}
